var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('banner'),_c('idle-timer'),(
			_vm.$route.path !== '/insight' &&
			((_vm.brand() !== 'guild' && _vm.brand() !== 'childcare') ||
				((_vm.brand() === 'guild' || _vm.brand() === 'childcare') &&
					_vm.isNewUrl()))
		)?_c('router-view'):_vm._e(),(_vm.allPermission() && _vm.allPermission().length > 0 && _vm.isLoggedIn())?_c('insight-page',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path === '/insight'),expression:"$route.path === '/insight'"}]}):_vm._e(),_c('portal-notifications'),(_vm.isLoggedIn())?_c('user-login-notification'):_vm._e(),_c('upscope')],1)}
var staticRenderFns = []

export { render, staticRenderFns }